import { FC } from 'react';
import { EmptyState } from '@/shared/ui';

/** Один элемент вертикальной столбчатой диаграммы */
export type ColumnChartItem = {
  /** Категория — подпись под столбиком (например, `YYYY-MM`) */
  label: string;
  /** Численное значение — высота столбика */
  value: number;
};

type Props = {
  items: ColumnChartItem[];
  /** Максимум шкалы, к которому нормируется высота столбиков */
  maxValue: number;
};

/**
 * Классическая столбчатая диаграмма: ось X — категории, ось Y — значение.
 * Столбики растут вверх. Над каждым столбиком — численное значение целым числом
 * (ru-локаль для разделителя разрядов).
 */
export const ColumnChart: FC<Props> = ({ items, maxValue }) => {
  if (items.length === 0) return <EmptyState />;

  return (
    <div className="flex items-end gap-2 h-48 overflow-x-auto pb-2">
      {items.map((item) => {
        const pct = maxValue > 0 ? (item.value / maxValue) * 100 : 0;
        const heightPct = `${Math.max(2, pct)}%`;
        return (
          <div key={item.label} className="flex flex-col items-center gap-1 flex-1 min-w-12 h-full justify-end">
            <span className="text-xs font-bold">{Math.round(item.value).toLocaleString('ru-RU')}</span>
            <div className="w-full bg-primary rounded-t-md transition-all" style={{ height: heightPct }} />
            <span className="text-xs text-muted-foreground whitespace-nowrap">{item.label}</span>
          </div>
        );
      })}
    </div>
  );
};
